import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    // { key: 'id', sortable: true },
    { key: 'name', label: 'name', sortable: true },
    { key: 'country.name', label: 'Country', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('region'),
  }
}
